import { render } from "./VideoStreamControl.vue?vue&type=template&id=1f87062e&scoped=true"
import script from "./VideoStreamControl.vue?vue&type=script&lang=js"
export * from "./VideoStreamControl.vue?vue&type=script&lang=js"

import "./VideoStreamControl.vue?vue&type=style&index=0&id=1f87062e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f87062e"]])

export default __exports__